import { Injectable } from '@angular/core';
import { Paginator } from '@app/classes';
import { ApplicantInterviews } from '@app/models/recruiting/applicant-interviews.model';
import { Applicant } from '@app/models/recruiting/applicant.model';
import { Table } from '@app/modules/table/classes/table.class';
import { FeedbackDueBy } from './columns/feedback-due-by.column';
import { FeedbackSubmitted } from './columns/feedback-submitted.column';
import { InterviewColumn } from './columns/interview.column';
import { InterviewersColumn } from './columns/interviewers.column';

@Injectable()
export class ApplicantInterviewsTable extends Table {
    links = true;
    showMenuColumnOptions = true;

    constructor(private applicant: Applicant) {
        super();
        this.boot();
    }

    getLink(applicantInterview: ApplicantInterviews): (string | number)[] {
        return [
            '/recruiting',
            'jobPostings',
            applicantInterview.interview.atsJobId,
            'interviews',
            'applicantInterviews',
            applicantInterview.id,
        ];
    }

    setColumns(): void {
        this.addColumns(new InterviewColumn(), new InterviewersColumn(), new FeedbackDueBy(), new FeedbackSubmitted());
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            ApplicantInterviews.where('atsApplicantId', this.applicant.id).with([
                'interview',
                'applicantInterviewers',
                'applicantInterviewers.interviewer',
            ])
        );
    }
}
